import { Route, Routes } from "react-router-dom";
import ErrorPage from "../../pages/ErrorPage";
import AdminDashboard from "../../pages/admin/AdminDashboard";
import AdminProfile from "../../pages/admin/AdminProfile";
import Assistant from "../../pages/assistant/Assistant";
import ProgramEditor from "../../pages/programs/ProgramEditorRouter";
import PaginatedTransactions from "../../pages/payments/PaginatedTransactions";
import InvitationsManager from "../../components/users/InvitationManager";
import PaginatedReports from "../../pages/reports/PaginatedReports";
import ReportPage from "../../pages/reports/ReportPage";
import QAReportEditGuard from "../../components/routes/QAReportEditGuard";
import PaginatedPrograms from "../../pages/programs/PaginatedPrograms";
import ProgramPage from "../../pages/programs/ProgramPage";
import RetestManagement from "../../pages/retests/RetestManagent";
import RetestPage from "../../pages/retests/RetestPage";
import PentestReports from "../../pages/automated-report/PentestReports";
import PaginatedUsers from "../../pages/users/PaginatedUsers";
import OrgSettingsPage from "../../pages/settings/OrgSettingsPage";
import ProgramChecklistEditor from "../../pages/admin/ProgramChecklistEditor";
import ChecklistItemWorkspace from "../../pages/researcher/ChecklistItemWorkspace";
import ChecklistReviewQueue from "../../pages/admin/ChecklistReviewQueue";
import DelegationManagement from "../../pages/delegations/DelegationManagement";
import QAPentestReportEditGuard from "../../components/routes/QAPentestReportEditGuard";
import OnboardingDocumentationRoutes from "./OnboardingDocumentationRoutes";
import CommentsPage from "../../pages/admin/CommentsPage";
import NotificationsPage from "../../pages/notifications/NotificationsPage";

const QARoutes = () => {
  return (
    <Routes>
      <Route index element={<AdminDashboard />} />

      <Route path="programs/:id/edit" element={<ProgramEditor />} />
      <Route path="/create-program" element={<ProgramEditor />} />
      <Route path="invitation" element={<InvitationsManager />} />

      <Route path="profile/*" element={<AdminProfile />} />
      <Route path="settings/*" element={<OrgSettingsPage />} />
      <Route path="reports" element={<PaginatedReports />} />
      <Route path="reports/:id" element={<ReportPage />} />
      <Route path="reports/:id/edit" element={<QAReportEditGuard />} />

      <Route path="programs" element={<PaginatedPrograms />} />
      <Route path="programs/:id" element={<ProgramPage />} />
      <Route path="programs/:programId/checklists/:checklistId" element={<ProgramChecklistEditor />} />
      <Route path="programs/:programId/runs/:runId/checklists/:checklistId" element={<ProgramChecklistEditor />} />


      {/* Checklist Review Routes */}
      <Route path="checklist-review" element={<ChecklistReviewQueue />} />
      <Route path="checklist-review/items/:itemId" element={<ChecklistItemWorkspace />} />

      <Route path="/retests" element={<RetestManagement />} />
      <Route path="/retests/:retest_id" element={<RetestPage />} />

      <Route path="users" element={<PaginatedUsers />} />

      <Route path="delegations" element={<DelegationManagement />} />
      <Route path="assistant/*" element={<Assistant />} />

      <Route path="payments/*" element={<PaginatedTransactions />} />
      <Route path="pentest-reports" element={<PentestReports />} />
      <Route path="pentest-reports/:report_id/edit" element={<QAPentestReportEditGuard />} />
      <Route path="comments" element={<CommentsPage />} />
      <Route path="notifications" element={<NotificationsPage />} />

      <Route path="onboarding-documentation/*" element={<OnboardingDocumentationRoutes />} />
      <Route path="/*" element={<ErrorPage />} />
    </Routes>
  );
};

export default QARoutes;
